import {h, Fragment} from "preact"
import { useState, useEffect } from 'preact/hooks';
import { subscribeToSms } from '../../api'


export default function NotifyMe ({
    product = null,
    activeVariant = null,
    subFormRef
}) {
    const backInStockDate = null;
    const variantId = activeVariant?.productId || null;
    const productId = product.productId || null;

    const [attentiveZapierUrl, setAttentiveZapierUrl] = useState(null);
    const [sourceId, setSourceId] = useState(null);
    const [acceptsMarketing, setAcceptsMarketing] = useState(false);
    const [acceptsSms, setAcceptsSms] = useState(false);
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [showError, setShowError] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);

    useEffect(() => {
        const technicalDataEl = document.querySelector('[data-technical]');
        const data = technicalDataEl?.innerHTML && JSON.parse(technicalDataEl.innerHTML);
        if (data) {
            setSourceId(data.sourceId);
            setAttentiveZapierUrl(data.attentiveZapierUrl);
        }
    }, []);

    const handleSubscriptionResponse = (resp, onSuccess) => {
        if (resp.status === 'OK') {
            setShowSuccess(true);
            setShowError(false);
            if (onSuccess) onSuccess();
        } else {
            setShowError(true);
        }
    };

    const handleSubscribe = (event) => {
        event.preventDefault();
        setShowSuccess(false);
        setShowError(false);

        if (email && !phone) {
            window.BIS.create(email, variantId, productId, {
                accepts_marketing: acceptsMarketing,
            }).then((resp) => handleSubscriptionResponse(resp));
        } else if (phone && !email) {
            const isValid = window.libphonenumber.isValidPhoneNumber(phone, 'US');
            if (!isValid) {
                setShowError(true);
                return;
            }
            const parsedPhone = window.libphonenumber.parsePhoneNumber(phone, 'US');
            window.BIS.create(null, variantId, productId, {
                phone_number: parsedPhone.number,
            }).then((resp) => {
                handleSubscriptionResponse(resp, () =>
                    subscribeToSms(acceptsSms, email, parsedPhone.number, attentiveZapierUrl, sourceId)
                );
            });
        } else if (phone && email) {
            const isValid = window.libphonenumber.isValidPhoneNumber(phone, 'US');
            if (!isValid) {
                setShowError(true);
                return;
            }
            const parsedPhone = window.libphonenumber.parsePhoneNumber(phone, 'US');
            window.BIS.create(email, variantId, productId, {
                accepts_marketing: acceptsMarketing,
            }).then((resp) => {
                handleSubscriptionResponse(resp, () => {
                    window.BIS.create(null, variantId, productId, {
                        phone_number: parsedPhone.number,
                    }).then((resp2) =>
                        handleSubscriptionResponse(resp2, () =>
                            subscribeToSms(acceptsSms, email, parsedPhone.number, attentiveZapierUrl, sourceId)
                        ),
                    );
                });
            });
        } else {
            setShowError(true);
        }
    };

    return (
        <form onSubmit={handleSubscribe} className="py-4" ref={subFormRef}>
            <div
                className={`absolute bottom-0 bg-gray-0 w-full py-[12px] px-[9px] z-2 ${showSuccess ? 'hidden' : ''}`}
                data-back-in-stock
            >
            <p className="body-3--medium text-left">
                {window.TMW.Strings.product.backInStockTitle}
            </p>
            <p className="body-3 pb-[16px] text-left" data-back-in-stock-message>
                {backInStockDate && (
                    <>
                        {window.TMW.Strings.product.backInStockMessage}{' '}
                        {backInStockDate || backInStockDate.value}
                    </>
                )}
            </p>
            <input
                type="tel"
                placeholder="Phone Number"
                className="body-3 w-full mb-[8px] py-[10px] px-[10px] border border-gray-400 text-gray-900 focus:ring-0 focus:ring-transparent focus:border focus:border-gray-400"
                pattern="[0-9]*"
                onChange={(e) => setPhone(e.target.value)}
            />
            <input
                type="email"
                placeholder="Email Address"
                className="body-3 w-full mb-[8px] py-[10px] px-[10px] border border-gray-400 text-gray-900 focus:ring-0 focus:ring-transparent focus:border focus:border-gray-400"
                onChange={(e) => setEmail(e.target.value)}
            />
            <div className="flex items-center mb-[8px]">
                <input
                    type="checkbox"
                    id={`ns-${productId}-newsletterCheckbox`}
                    className="mr-2 text-gray-900 focus:ring-0 focus:ring-transparent focus:border focus:border-gray-400"
                    onClick={() => setAcceptsMarketing(!acceptsMarketing)}
                />
                <label htmlFor={`ns-${productId}-newsletterCheckbox`} className="body-3 cursor-pointer">
                    {window.TMW.Strings.product.backInStockNewsletter}
                </label>
            </div>
            <div
                className="flex items-center pb-[16px] relative"
                data-tooltip-icon-container
            >
                <input
                    type="checkbox"
                    id={`ns-${productId}-smsCheckbox`}
                    className="mr-2 text-gray-900
                    focus:ring-0 focus:ring-transparent focus:border focus:border-gray-400"
                    onClick={() => setAcceptsSms(!acceptsSms)}
                />
                <label
                    htmlFor={`ns-${productId}-smsCheckbox`}
                    className="body-3 cursor-pointer text-ellipsis whitespace-nowrap overflow-hidden"
                >
                    {window.TMW.Strings.product.backInStockSmsCheckbox}
                </label>
            </div>
            <div
                className="cursor-pointer bg-core-1 opacity-100"
                data-tooltip-message
            >
            <div
                className="relative w-full p-4 mb-4 left-1/2 transform -translate-x-1/2 cursor-default"
            >
                <div class="body-4 text-gray-900">
                    {window.TMW.Strings.product.backInStockTermsOfServices}{' '}
                    <a href="https://attnl.tv/t/eOC">
                        {window.TMW.Strings.product.backInStockTermsOfServicesLink}
                    </a>
                    {' & '}
                    <a href="https://attnl.tv/t/e0C">
                        {window.TMW.Strings.product.backInStockPrivacyPolicy}
                    </a>
                </div>
            </div>
        </div>
        <div
            className={`items-center mb-[16px] ${showError ? 'flex' : 'hidden'}`}
        >
            <p className="body-3 text-sale text-left">
                {window.TMW.Strings.product.backInStockError}
             </p>
        </div>
            <button
                className="button button--primary w-full"
                onClick={handleSubscribe}
                type="submit"
            >
                {window.TMW.Strings.product.backInStockButton}
            </button>
        </div>
        {showSuccess && (
            <div
                className='bg-gray-100 w-full py-[12px] px-[9px] absolute bottom-0'
            >
                <span className="body-3--medium">
                    {window.TMW.Strings.product.backInStockSuccessTitle}
                </span>{' '}
                <span className="body-3">
                    {window.TMW.Strings.product.backInStockSuccessCopy}
                </span>
            </div>
        )}
    </form>
)};